import OptionsModal from 'draft/modals/optionsModal';
import { DraftType } from 'draft/types';
import React, { useState } from 'react'
import { Grid, GridColumn, Button, Icon } from 'semantic-ui-react'

import { useMeleeContext } from '../context/MeleeContextProvider'

type Props = {
    draftType : DraftType;
    setDraftType : (draftType:DraftType) => void;
}

const MeleeDashboard = ({ draftType, setDraftType }: Props) => {
    const context = useMeleeContext();
    const [optionsModalOpen, setOptionsModalOpen] = useState(false);

    const clearNames = () => {
        let stateWithoutNames = Object.assign({}, context?.gameData);
        context?.players.forEach((player) => {
            player.Name = '';
        });
        context?.setGameData(stateWithoutNames);
    }

    return (
        <>
        <Grid columns={3} divided style={{ marginTop: '3em' }}>
            <GridColumn>
                <select
                    className='melee-dropdown'
                    value={draftType}
                    onChange={(e: any) => setDraftType(e.target.value)}
                    style={{margin:'auto'}}
                >
                    <option value={DraftType.Teams}>Teams </option>
                    <option value={DraftType.FFA}>Free-for-all</option>
                    <option value={DraftType.Duel}>Duel</option>
                </select>
            </GridColumn>
            <GridColumn>
                <Button
                    basic
                    icon className='melee'
                    labelPosition='left'
                    onClick={() => clearNames()}
                >
                    <Icon name='eraser' />
                    Clear names
                </Button>
            </GridColumn>
            <GridColumn>
            <Button
                    basic
                    icon className='melee'
                    labelPosition='left'
                    onClick={() => setOptionsModalOpen(true)}
                >
                    <Icon name='cog' />
                    Options
                </Button>
            </GridColumn>
        </Grid>
        <OptionsModal 
            open={optionsModalOpen}
            setOpen={setOptionsModalOpen}
        />
        </>
    )
}

export default MeleeDashboard;